import * as actionsTypes from '../actions/actionsTypes';

const initialState = {
  selectValue: 'All',
  searchQuery: '',
  loading: false,
  result: [],
  maxPages: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.SEARCH_QUERY_CHANGED: {
      return {
        ...state,
        searchQuery: action.query,
      };
    }

    case actionsTypes.INF_SEARCH_PENDING: {
      return {
        ...state,
        result: [],
        loading: true,
      };
    }

    case actionsTypes.INF_SEARCH_FULFILLED: {
      return {
        ...state,
        result: action.payload.results,
        loading: false,
        maxPages: action.payload.pages,
      };
    }

    case actionsTypes.SELECT_VALUE_CHANGED: {
      return {
        ...state,
        selectValue: action.value,
      };
    }

    default:
      return state;
  }
};

export default reducer;
